
class DoubleListCtrl {
  constructor(FlashService) {
    'ngInject';
    this.fs = FlashService;
    this.selUnused = [];
    this.unused = [];
    this.used = [];
  }

  $onInit() {
    this.items = this.items || [];
    this.updateItems();
  }

  addSelected() {
    if (!this.selUnused.length) return;
    if (this.maxItems && (this.items.length + this.selUnused.length) > this.maxItems) {
      this.fs.error(`You can only select up to ${this.maxItems} items!`);	
      return;
    }
    this.items = this.items.concat(this.selUnused.map(u => u.id));
    this.updateItems();
  }

  removeSelected() {
    if (!this.selUsed.length) return;
    this.items = this.items.filter(i => !this.selUsed.some(u => u.id == i));
    this.updateItems();
  }

  updateItems() {
    this.unused = this.available.filter(a => !this.items.includes(a.id));
    this.used = this.items.map(id => this.available.find(a => a.id == id) || { id, label: `[${id}: MISSING]` });
  }

  orderSelected(direction) {
    if (!this.selUsed.length) return;
    const maxIndex = this.items.length - 1;
    const dirVal = direction === 'up' ? -1 : 1;
    this.selUsed.forEach(i => {
      const index = this.items.indexOf(i.id);
      let newPos = index;
      while (this.selUsed.find(i => i.id == this.items[newPos])) {
        newPos += dirVal;
        if (newPos > maxIndex || newPos < 0) return;
      }
      this.items.splice(newPos, 0, this.items.splice(index, 1)[0]);
    });
    this.updateItems();
  }

  usedKeyDown(e) {
    if (['ArrowLeft', 'Enter', 'Delete'].includes(e.key)) {
      this.removeSelected();
      e.preventDefault();
    }
  }

  unusedKeyDown(e) {
    if (['ArrowRight', 'Enter'].includes(e.key)) {
      this.addSelected();
      e.preventDefault();
    }
  }
}

export default {
  bindings: {
    items: "=",
    available: "<",
    maxItems: "<",
  },
  templateUrl: "form-builder/forms/double-list/double-list.component.html",
  controller: DoubleListCtrl
}